angular.module('buyers', [
  'ngRoute'
  ,'ngCookies'
  ,'ngAnimate'
  ,'ngSanitize'
  ,'angular-cache'
  ,'infinite-scroll'
  ,'angular-gestures'
  ,'ngFileUpload'
  ,'mainController'
  ,'authController'
  ,'homeController'
  ,'mortgageController'
  ,'preferencesController'
  ,'openhomesController'
  ,'preferedPropertiesController'
  ,'whatchlistController'
  ,'listingSeenController'
  ,'buyingTipsController'
  ,'financeApplicationController'
  ,'changePasswordController'
  ,'servicesController'
  ,'feedController'
  ,'sellEnquiryController'
  // ,'offersController'
  // ,'mailController'
  // ,'taskController'
  // ,'contactsController'
  // ,'settingsController'
  // ,'agentController'
  // ,'agencyController'
  // ,'propertyController'
  ,'buyersService'
  
])
.config(function($routeProvider, $locationProvider) {
  $locationProvider.html5Mode(true);
  $routeProvider.when('/', 
                     { templateUrl: 'login.html'
                      , controller: 'AuthController' })
                .when('/login',     
                      { templateUrl: 'login.html'
                      , controller: 'AuthController' })
                // Home
                .when('/home',     
                      { templateUrl: 'home.html'
                      , controller: 'HomeController' })
                .when('/preferences',     
                      { templateUrl: 'preferences.html'
                      , controller: 'PreferencesController' })
                .when('/mortgage-calculator',     
                      { templateUrl: 'mortgageCalculator.html'
                      , controller: 'MortgageController' })
                .when('/openhomes',     
                      { templateUrl: 'openHomes.html'
                      , controller: 'OpenHomesController' })
                .when('/prefered-properties',     
                      { templateUrl: 'preferedProperties.html'
                      , controller: 'PreferedPropertiesController' })
                .when('/watchlist',     
                      { templateUrl: 'watchlist.html'
                      , controller: 'WatchlistController' })
                .when('/listing-seen',     
                      { templateUrl: 'listingSeen.html'
                      , controller: 'ListingSeenController' })
                .when('/buying-tips',     
                      { templateUrl: 'buyingTips.html'
                      , controller: 'BuyingTipsController' })
                .when('/finance-application',     
                      { templateUrl: 'financeApplication.html'
                      , controller: 'FinanceApplicationController' })
                .when('/change-password', 
                      { templateUrl: 'changePassword.html'
                      , controller: 'ChangePasswordController' })
                .when('/services', 
                      { templateUrl: 'services.html'
                      , controller: 'ServicesController' })
                .when('/news', 
                      { templateUrl: 'feed.html'
                      , controller: 'FeedController' })
                .when('/sell-enquiry', 
                      { templateUrl: 'sellEnquiry.html'
                      , controller: 'SellEnquiryController' })
                // // Cookings
                // .when('/offers', 
                //       { templateUrl: 'offers.html'
                //       , controller: 'OffersController' })
                // // Mail
                // .when('/mail', 
                //       { templateUrl: 'mailbox.html'
                //       , controller: 'MailController' })
                // // Mail -> New
                // .when('/mail/new', 
                //       { templateUrl: 'newMail.html'
                //       , controller: 'MailController' })
                // // Mail - Message
                // .when('/mail/message/:id', 
                //       { templateUrl: 'message.html'
                //       , controller: 'MailController' })
                // // Activity
                // .when('/activity', 
                //       { templateUrl: 'tasks.html'
                //       , controller: 'TaskController' })
                // // Activity -> Event
                // .when('/activity/event/:id', 
                //       { templateUrl: 'task.html'
                //       , controller: 'TaskController' })
                //  // Listing
                // .when('/property/:state/:id', 
                //         { templateUrl: 'property.html'
                //         , controller:  'PropertyController' })
                //  //  Agency
                // .when('/agency/:identifier', 
                //         { templateUrl: 'agency.html'
                //         , controller: 'AgencyController' })
                // //  Agent
                // .when('/agent/:id', 
                //         { templateUrl: 'agent.html'
                //         , controller: 'AgentController' })
                // // Settings
                // .when('/settings', 
                //       { templateUrl: 'settings.html'
                //       , controller: 'SettingsController' })
                // .when('/feed', 
                //       { templateUrl: 'feed.html'
                //       , controller: 'FeedController' })
                .otherwise('/');
})
.constant('appInfo', {
            version: '2.0'
            ,name : 'Wiseberry Sellers'
            ,key : 'U8b334Ng'
            ,pkey: 'kSvkpR4H'
            ,production : true
            ,endpoint : 'http://mapp.wiseberryonline.com.au/w3/'
            ,today: moment().unix()
            ,updated: 'Friday, March 31 2017'
            ,pages: {
               preferences: { 
                  title: 'What am I looking for?',
                  helpText:  
                          '<p><b>From:</b> The lowest price you are looking to buy a property for.</p>' +
                          '<p><b>To:</b> The highest price you are looking to buy a property for.</p>' +
                          '<p><b>Suburbs:</b> The suburbs you are looking to buy a property in. To select a suburb, simply begin typing its name into the text box and tap the relevant suburb in the drop down menu. To select multiple suburbs, begin typing another suburb after one has been selected.</p>' +
                          '<p><b>Bed:</b> The number of bedrooms you are looking for.</p>' +
                          '<p><b>Bath:</b> The number of bathrooms you are looking for.</p>' +
                          '<p><b>Car:</b> The number of car spaces you are looking for.</p>' +
                          '<p><b>Pool:</b> Identifies whether you are looking for a property with a pool.</p>' +
                          '<p><b>House, Townhouse / Duplex / Villa, Apartment / Unit, Land:</b> The type of property you are looking for.</p>' +
                          '<p><b>Save:</b> Saves your preferences and loads the "Homes I may want to buy" page.</p>'
               },
               preferedProperties: { 
                  title: 'Homes I may want to buy',
                  helpText:  
                          '<p><b>Homes I may want to buy:</b> A list of properties that match the preferences you have set in the "What am I looking for?" page.</p>' +
                          '<p>If no properties appear, try removing some of your preferences to make the search less specific.</p>' +
                          '<p><b>(+):</b> Opens a menu with the following options:</p>' +
                          '<p><b>1. Add to watch list</b> - Adds a property that you are interested in to your watch list, where you will receive notifications each time that property has an update.</p>' +
                          '<p><b>2. Register for open home</b> - Notifies your Wiseberry office to register you for an upcoming open home.</p>' +
                          '<p><b>3. Enquire about this home</b> - Sends an enquiry to your Wiseberry office about a property.</p>' +
                          '<p><b>4. What is it like to live here?</b> - Allows you to view all posts related to a property that have been created by the seller or agent, providing you with a personal insight into what it is like to live at there.</p>' +
                          '<p><b>5. What are my finance options?</b> - Provides you with an instant idea of what your monthly loan repayments could be for a property.</p>'
               },
               finance: { 
                  title: 'Looking for a finance solution?',
                  helpText: 
                          '<p><b>Looking for a finance solution?:</b> A quick and easy calculator that provides you with an instant idea of what your monthly loan repayments could be for a particular property.</p>' +
                          '<p><b>Loan amount:</b> The amount you are looking to borrow.</p>' +
                          '<p><b>$:</b> Your estimated monthly loan repayments, based on the lowest available rate advertised by one of the most competitive lenders.</p>' +
                          '<p><b>Apply now:</b> Allows you to notify your Wiseberry office that you are looking for a home loan to assist you with the buying process.</p>' 
                },
               financeApplication: { 
                  title: 'Finance application',
                  helpText: 
                          '<p><b>What best describes your request?:</b> Information about your circumstances that will assist in finding the right lender for you.</p>' +
                          '<p><b>Yes, I have read the disclaimer:</b> Identifies that you have read and agree to the legal disclaimer.</p>' +
                          '<p><b>Let\'s get started!:</b> Sends a request to your Wiseberry office to refer you to a Licensed Credit Provider to find the right banker for your circumstances.</p>' 
               },
               watchList: { 
                  title: 'My watch list',
                  helpText: 
                          '<p><b>My watch list:</b> The list of properties you have added to your watch list.</p>' +
                          '<p><b>(1):</b> Identifies that a change has been made to a property, such as a price change or open home. Tap to open a list of all notifications.</p>' +
                          '<p><b>(+):</b> Opens a menu with the following options:</p>' +
                          '<p><b>1. Remove from watch list</b> – Removes the property from your watch list.</p>' +
                          '<p><b>2. Register for open home</b> – Notifies your Wiseberry office to register you for an upcoming open home.</p>' +
                          '<p><b>3. Enquire about this home</b> – Sends an enquiry to your Wiseberry office about a property.</p>' +
                          '<p><b>4. What is it like to live here?</b> – Allows you to view all posts related to a property that have been created by the seller or agent, providing you with a personal insight into what it is like to live at there.</p>' +
                          '<p><b>5. What are my finance options?</b> - Provides you with an instant idea of what your monthly loan repayments could be for a property.</p>' 
                          
               },
               openHomes: { 
                  title: 'Upcoming open homes',
                  helpText: 
                          '<p><b>Upcoming open homes:</b> A list of all upcoming open homes that have been scheduled by your Wiseberry office, sorted by date and time.</p>'+
                          '<p><b>(+):</b> Opens a menu with the following options:</p>'+
                          '<p><b>1. Add to watch list</b> – Adds a property that you are interested in to your watch list, where you will receive notifications each time that property has an update.</p>' +
                          '<p><b>2. Register for open home</b> – Notifies your Wiseberry office to register you for an upcoming open home.</p>' +
                          '<p><b>3. Enquire about this home</b> – Sends an enquiry to your Wiseberry office about a property.</p>' +
                          '<p><b>4. What is it like to live here?</b> – Allows you to view all posts related to a property that have been created by the seller or agent, providing you with a personal insight into what it is like to live at there.</p>' +
                          '<p><b>5. What are my finance options?</b> - Provides you with an instant idea of what your monthly loan repayments could be for a property.</p>'
               },
               openHomeRegisteration: { title: 'Register for open home'},
               listingSeen: { 
                  title: 'What have I seen?',
                  helpText: 
                          '<p><b>What have I seen?:</b> A list of all properties you have visited at past open homes or appointments with your Wiseberry office.</p>' +
                          '<p><b>(+):</b> Opens a menu with the following options:</p>' +
                          '<p><b>1. Add to watch list</b> – Adds a property that you are interested in to your watch list, where you will receive notifications each time that property has an update.</p>' +
                          '<p><b>2. Register for open home</b> – Notifies your Wiseberry office to register you for an upcoming open home.</p>' +
                          '<p><b>3. Enquire about this home</b> – Sends an enquiry to your Wiseberry office about a property.</p>' +
                          '<p><b>4. What is it like to live here?</b> – Allows you to view all posts related to a property that have been created by the seller or agent, providing you with a personal insight into what it is like to live at there.</p>' +
                          '<p><b>5. What are my finance options?</b> - Provides you with an instant idea of what your monthly loan repayments could be for a property.</p>'
               },
               buyingTips: { 
                  title: 'Buying tips',
                  helpText: '<p><b>Buying tips:</b> A variety of tips and advice regarding the buying process that you may find helpful.</p>'
               },
               enquiry: { 
                  title: 'Enquiry',
                  helpText: 
                          '<p><b>Enquiry:</b> Allows you to send an enquiry to your Wiseberry office about a property.</p>'+
                          '<p><b>Name / Email / Phone:</b> Your contact details.</p>'+
                          '<p><b>About me:</b> Information about your current situation that will assist the agent with your enquiry (e.g. first home buyer, I am looking to invest).</p>'+
                          '<p><b>I would like to:</b> Identifies the desired outcome of your enquiry.</p>'
               },
               post: { 
                  title: 'What is it like to live here?',
                  helpText: '<p><b>What is it like to live here?:</b> An exclusive list of posts that have been created by the seller or agent for a particular property, providing you with a personal insight into what it is like to live at the property. These posts may appear in text, image or video form.</p>'
               },
               watchListNotification: { title: 'Notifications'},
               changePassword: { 
                  title: 'Settings',
                  helpText: 
                          '<p><b>Username:</b> Your Wiseberry Buyers username. </p>' +
                          '<p><b>Note:</b> Your username cannot be changed. Please contact your Wiseberry office if you require a new username.</p>' +
                          '<p><b>Password:</b> Your new Wiseberry Buyers password.</p>' +
                          '<p><b>Update:</b> Updates your log in details.</p>' 
               },
               services: { 
                  title: 'Services',
                  helpText: '<p><b>Services:</b> A list of services that may assist you in the buying process. Where available, tapping a service will open the company\'s website.</p>'
               },
               news: { 
                  title: 'Office news feed',
                  helpText: '<p><b>Office News Feed:</b> A feed of activity from the office you are selling with.</p>'
               },
               sellEnquiry: { title: 'Thinking about selling?'}
            }
        })
.constant('assoc_offices', {data: [[123,214,243,252,253,254,256], [236,250],[235,245],[231,249]]})
.constant("Modernizr", Modernizr)
.config(function ($httpProvider) {
    delete $httpProvider.defaults.headers.common['X-Requested-With'];
})
.config(function (hammerDefaultOptsProvider) {
    hammerDefaultOptsProvider.set({
        recognizers: [
          [Hammer.Tap,{ event: 'tap'}],
          [Hammer.Tap, {time: 250}],
          [Hammer.Tap, { event: 'doubletap', taps: 2 }, [], ['tap']],
          [Hammer.Press],
          [Hammer.Pan]
        ]
    });
})
.config(function (CacheFactoryProvider) {
    angular.extend(CacheFactoryProvider.defaults, { maxAge: 15 * 60 * 1000, storageMode: 'localStorage' });
})
.run(['$rootScope', '$location', '$cookieStore', 'localstorage', '$http',
    function ($rootScope, $location, $cookieStore, localstorage, $http) {

       // Needed for the loading screen
      $rootScope.$on('$routeChangeStart', function(){
        $rootScope.loading = true;
      });

      $rootScope.$on('$routeChangeSuccess', function(){
        $rootScope.loading = false;
      });

      // keep user logged in after page refresh
      $rootScope.currentUser = localstorage.getObject('currentUser') || $cookieStore.get('currentUser') || {};

      $rootScope.$on('$locationChangeStart', function (event, next, current) {
          // Clear any cookies/storage and redirect to login page if not logged in
          if ($location.path() !== '/login' && (!$rootScope.currentUser || angular.equals($rootScope.currentUser, {}))) {
              $location.path('/login');
          } else {
                $rootScope.auth = true;
          }
      });
    }
]);